(function () {
  "use strict";

  function normalize(text) {
    return (text || "").trim().toLowerCase();
  }

  // Desktop only: swap the plain text submenu for the rich image panel.
  // Mobile keeps the theme's native accordion link list untouched.
  function applyToDesktop(template, targetTitle) {
    var items = document.querySelectorAll("[data-items-menu]");
    items.forEach(function (li) {
      var titleEl = li.querySelector(".menu-item-top span, .menu-item-top");
      if (normalize(titleEl && titleEl.textContent) !== targetTitle) return;

      var colItems = li.querySelector(".col-items");
      if (!colItems) return;

      var list = colItems.querySelector("ul.header__submenu");
      if (!list) return;

      list.replaceWith(template.content.cloneNode(true));
    });
  }

  function init() {
    var template = document.getElementById("shop-now-mega-menu-template");
    if (!template) return;

    var targetTitle = normalize(template.dataset.targetTitle);
    if (!targetTitle) return;

    applyToDesktop(template, targetTitle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
